import { render, staticRenderFns } from "./hjcxPhone.vue?vue&type=template&id=5277d706&"
import script from "./hjcxPhone.vue?vue&type=script&lang=js&"
export * from "./hjcxPhone.vue?vue&type=script&lang=js&"
import style0 from "./hjcxPhone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports